<template>
  <div id="app">
    <NavBar />
    <label id="labelForAdminToggle" for="playerIsGM">Toggle Admin Options</label>
    <input type="checkbox" name="playerIsGM" id="playerIsGM" v-model="playerIsGM" />
    <router-view
      id="router-view"
      :playerIsGM="playerIsGM"
      :playerCharacter="computedPlayerCharacter"

      :minionMap="minionMap"
      :entities="entities"
      :allies="allies"
      :players="players" todo="switch 'players' to be 'characters' instead"
      :monsters="monsters"
      :bosses="bosses"
      :bugs="bugs"
      :acceptedFeatures="acceptedFeatures"
      :ideas="ideas"
      :resources="resources"
      :scenarioAllies="scenarioAllies"
      :scenarioCharacters="scenarioCharacters"
      :scenarioMonsters="scenarioMonsters"
      :scenarioBosses="scenarioBosses"
      :presentAllies="presentAllies"
      :presentCharacters="presentCharacters"
      :presentMonsters="presentMonsters"
      :presentBosses="presentBosses"
      :presentEntities="presentEntities"

      :entitiesHaveLoaded="entitiesHaveLoaded"

      :watcherDoc="watcherDoc"

      :deleteEntity="deleteEntity"
      :toggleActivation="toggleActivation"
      :entityUpdate="entityUpdate"
      :togglePresence="togglePresence"
      :updatePresence="updatePresence"
      @playerSelectsCharacter="playerSelectsCharacter"
      @toggle-presence="togglePresence"
      @update-presence="updatePresence"
      @entity-update="entityUpdate"
      @watcherdoc-update="watcherDocUpdate"
      />
    <Minion v-for="minionDoc in minionMap" :key="minionDoc.id" :docData="minionDoc"></Minion>
    
  </div>
</template>

<script>
import db from '@/firebase/init'
import NavBar from '@/components/NavBar'
import firebase from 'firebase'
import Minion from '@/components/Minion'

export default {
  name: 'App',
  components: {
    NavBar,
    Minion
  },
  data () {
    return {
      entities: [],
      playerIsGM: false,
      playerCharacter: {},
      watcherDoc: {},
      minionMap: {},
    }
  },
  created () {
    // fetch data from firestore
    // db.collection('entities').get()
    // .then(snapshot => {
    //   snapshot.forEach(doc => {
    //     let entity = doc.data()
    //     entity.id = doc.id
    //     this.entities.push(entity)
    //   })
    // })
    window.firebase = firebase
    db.collection('entities')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(change => {

        if (change.type == 'added'){
          console.log('adding via snapshot thingy')
          let entity = change.doc.data()
          entity.id = change.doc.id
          this.entities.push(entity)

        } else if (change.type == 'modified') {
          console.log('change occurred', change.doc.id, "change:", change)
          let changedEntity = change.doc.data()
          let matchingLocalEntity = this.entities.find(element => element.id == change.doc.id)
          let mle = matchingLocalEntity
          let ce = changedEntity
          mle.inScenario = ce.inScenario
          mle.initiative = ce.initiative
          // mle.isActive = ce.isActive // think we're phasing this attribute out
          mle.isGM = ce.isGM
          mle.isPresent = ce.isPresent
          mle.name = ce.name
          mle.subInitiative = ce.subInitiative
          mle.type = ce.type
          mle.hasGone = ce.hasGone
          mle.imageID = ce.imageID
          console.log('updated?', mle, ce)

        } else {
          console.log('change type is:', change.type, change)
        }
      })
    })
    let self = this
    db.collection('minions').onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(change => {
        switch(change.type) {
          case 'added':
          case 'modified':
            let data = change.doc.data()
            data.id = change.doc.id
            // delete this.minionMap[change.doc.id]
            this.minionMap[change.doc.id] = data
            console.log('added/modified minion:', change.doc.id)
            this.$forceUpdate()
            // v-for="minionDoc in minionMap" :key="minionDoc.id" :doc="minionDoc"
            // Minion({props: {doc: change.doc}})
            break
          case 'delete':
            delete this.minionMap[change.doc.id]
            break
        }
      })
    })

    db.collection('watchers')
    .onSnapshot((snapshot) => {
      snapshot.docChanges().forEach(change => {

        switch(change.type) {
          case 'added':
            let watcherDoc = change.doc.data()
            watcherDoc.id = change.doc.id
            this.watcherDoc = watcherDoc
            break;
          case 'modified':
            let changedWatcher = change.doc.data()
            this.watcherDoc.readyToRestartRound = changedWatcher.readyToRestartRound
            this.watcherDoc.elementsReduced = changedWatcher.elementsReduced
            this.watcherDoc.allShufflesShuffled = changedWatcher.allShufflesShuffled
            this.watcherDoc.roundCount = changedWatcher.roundCount
            break;
          case 'delete':
            console.log('wtf. WHO WOULD DO THIS')
            break;
        }
      })
    })
  },
  computed: {
    entitiesHaveLoaded() {
      return this.entities.length > 0
    },
    allies() {
      return this.entities.filter(entity => entity.type=="ally")
    },
    players() {
      return this.entities.filter(entity => entity.type=="player")
    },
    characters() {
      return this.players
    },
    monsters() {
      return this.entities.filter(entity => entity.type=="monster")
    },
    bosses() {
      return this.entities.filter(entity => entity.type=="boss")
    },
    bugs() {
      return this.entities.filter(entity => entity.type=="bug")
    },
    acceptedFeatures() {
      return this.entities.filter(entity => entity.type=="acceptedFeature")
    },
    ideas() {
      return this.entities.filter(entity => entity.type=="idea")
    },
    resources() {
      return this.entities.filter(entity => entity.type=="resource")
    },
    scenarioEntities() {
      return this.entities.filter(entity => entity.inScenario==true)
    },
    scenarioAllies() {
      return this.allies.filter(entity => entity.inScenario==true)
    },
    scenarioCharacters() {
      return this.characters.filter(entity => entity.inScenario==true)
    },
    scenarioMonsters() {
      return this.monsters.filter(entity => entity.inScenario==true)
    },
    scenarioBosses() {
      return this.bosses.filter(entity => entity.inScenario==true)
    },
    presentEntities() {
      return this.scenarioEntities.filter(entity => entity.isPresent==true)
    },
    presentAllies() {
      return this.scenarioAllies.filter(entity => entity.isPresent==true)
    },
    presentCharacters() {
      return this.scenarioCharacters.filter(entity => entity.isPresent==true)
    },
    presentMonsters() {
      return this.scenarioMonsters.filter(entity => entity.isPresent==true)
    },
    presentBosses() {
      return this.scenarioBosses.filter(entity => entity.isPresent==true)
    },
    selectedCharacter(){
      let list = this.players.filter(player => this.$route.params.name == player.name)
      if(list.length > 0){
        return list[0]
      } else {
        return null
      }
    },
    computedPlayerCharacter(){
      if(this.playerCharacter.hasOwnProperty('id')){
        return this.playerCharacter
      } else {
        return this.selectedCharacter
      }
    }
  },
  methods: {
    deleteEntity(entity){
      let id = entity.id
      console.log('deleting entity', id)
      db.collection("entities").doc(id).delete()
      .then(() => {
        this.entities = this.entities.filter(entity => {
          return entity.id != id
        })
      })
    },
    // update activation status for setting up scenario characters
    toggleActivation(entity) {
      console.log('swapping entity.inScenario', entity.name, entity.inScenario, entity)
      
      if (entity.type == 'monster' || entity.type == 'boss' || entity.type == 'ally') {
        if (entity.inScenario && !entity.isPresent) {
          entity.isPresent = true
        } else if (entity.inScenario && entity.isPresent) {
          entity.inScenario = false
          entity.isPresent = false
        } else {
          entity.inScenario = true
          entity.isPresent = false
        }
      } else {
        entity.inScenario = !entity.inScenario
        entity.isPresent = entity.inScenario
      }

      db.collection('entities').doc(entity.id).update({
        inScenario: entity.inScenario,
        isPresent: entity.isPresent,
      }).catch(err => {
        console.log(err)
      })
    },
    playerSelectsCharacter(entity){
      console.log('setting player character', entity.name, entity.inScenario, entity.isPresent, entity)
      entity.inScenario = true
      entity.isPresent = true
      entity.initiative = ''
      entity.subInitiative = ''
      this.playerCharacter = entity
      db.collection('entities').doc(entity.id).update({
        inScenario: entity.inScenario,
        isPresent: entity.isPresent,
        initiative: entity.initiative,
        subInitiative: entity.subInitiative,
      })
      .then(result => {console.log(result)})
      .catch(err => {console.log(err)})
    },
    togglePresence(entity){
      console.log('toggline presence for', entity)
    },
    updatePresence(entity, direction){
      console.log('updating presence for', entity, direction)
      entity.isPresent = !entity.isPresent
      db.collection('entities').doc(entity.id).update({
        isPresent: entity.isPresent,
      })
      .then(result => {})
      .catch(err => {console.log(err)})
    },
    entityUpdate(entity, propName) {
      console.log('entity update:', propName, entity)
      let thisUpdate = {}
      thisUpdate[propName] = entity[propName]
      console.log('update will be:', thisUpdate, entity, propName)
      db.collection('entities').doc(entity.id).update(thisUpdate)
      .then(result => {console.log('updated entity', result)})
      .catch(err => {console.log('error with entityUpdate', err.message, err)})
    },
    watcherDocUpdate(propName, optionalValue) {
      if (optionalValue != undefined) {
        this.watcherDoc[propName] = optionalValue
      }
      let thisUpdate = {}
      thisUpdate[propName] = this.watcherDoc[propName]
      db.collection('watchers').doc(this.watcherDoc.id).update(thisUpdate)
      .catch(err => console.log(err))
    }
  },
  mounted(){
    firebase.auth().onAuthStateChanged((user) => {
      if(!user) {
        this.$router.push({ name: 'Login' })
      } else {
        console.log("user is logged in")
      }
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 50px;
}

/* utility css */
.flex-clear{
  flex-basis: 100%;
}


#router-view {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue